import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHead } from "@/components/Bits";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { P } from "@/components/studio/portalKit";
import { DeskOrders } from "@/components/desk/DeskOrders";
import { DeskQueue } from "@/components/desk/DeskQueue";
import { DeskStudios } from "@/components/desk/DeskStudios";
import { DeskInspections, DeskRolls } from "@/components/desk/DeskRolls";

const TABS = [
  { key: "orders", label: "Studio Orders", roles: ["network_admin", "accountant", "sales_manager_products"], count: "orders", el: (r) => <DeskOrders onChange={r} /> },
  { key: "plan-pay", label: "Plan Payments", roles: ["network_admin", "accountant"], count: "plan_payments", el: (r) => <DeskQueue mode="plan-pay" onChange={r} /> },
  { key: "warranty", label: "Warranty Queue", roles: ["network_admin", "crm"], count: "warranties", el: (r) => <DeskQueue mode="warranty" onChange={r} /> },
  { key: "plan", label: "Protection Plan Queue", roles: ["network_admin", "crm"], count: "plans", el: (r) => <DeskQueue mode="plan" onChange={r} /> },
  { key: "rolls", label: "Roll Replacement", roles: ["network_admin", "accountant"], el: () => <DeskRolls /> },
  { key: "studios", label: "Studio Accounts", roles: ["network_admin", "sales_manager_products"], el: () => <DeskStudios /> },
  { key: "inspections", label: "Inspection Reports", roles: ["network_admin"], el: () => <DeskInspections /> },
];

export const DESK_ROLES = ["network_admin", "accountant", "sales_manager_products", "crm"];

export default function StudioDesk() {
  const { user } = useAuth();
  const [counts, setCounts] = useState({});
  const refresh = () => api.get(`${P}/central/summary`).then(({ data }) => setCounts(data)).catch(() => {});
  useEffect(() => { refresh(); }, []);
  const tabs = TABS.filter((t) => t.roles.includes(user.role));
  return (
    <div className="space-y-6">
      <PageHead title="Studio Desk" subtitle="Orders, protection plan payments and warranty registrations coming from studios." />
      <Tabs defaultValue={tabs[0]?.key}>
        <TabsList className="flex h-auto flex-wrap justify-start">
          {tabs.map((t) => (
            <TabsTrigger key={t.key} value={t.key} data-testid={`desk-tab-${t.key}`} className="gap-2">
              {t.label}
              {counts[t.count] > 0 && <span data-testid={`desk-count-${t.key}`} className="rounded-full bg-crimson-500 px-1.5 text-[10px] font-bold text-white">{counts[t.count]}</span>}
            </TabsTrigger>
          ))}
        </TabsList>
        {tabs.map((t) => <TabsContent key={t.key} value={t.key} className="pt-2">{t.el(refresh)}</TabsContent>)}
      </Tabs>
    </div>
  );
}
